export const HOST = process.env.REACT_APP_HOST_DEVEL || window.location.origin;
export const URL_AUTH = `${HOST}/auth`;
export const URL_USER = `${HOST}/auth/user`;
export const URL_SERVER = `${HOST}/server/get`;
export const URL_MARKS = `${HOST}/marks`;
export const URL_SMC = `${HOST}/smc`;
export const URL_SEE = `${HOST}/see`;
export const URL_SPR = `${HOST}/spr`;
export const URL_TRANSCRIPTION = `${HOST}/transcription`;
export const URL_SBS = `${HOST}/sbs`;
export const URL_TTS = `${HOST}/tts`;
export const URL_QAS = `${HOST}/qas`;
export const URL_SES = `${HOST}/ses`;
export const URL_RES = `${HOST}/res`;
export const URL_CLS = `${HOST}/cls`;
export const URL_LANG = `${HOST}/lang`; // словарь для перевода текста

export const ENDPOINTS_LANG = {
	LIST: "list", // список переводов
	WALLPAPER: "wallpaper", // случайные обои (get)
	CHANNELS: "channels", // список каналов (get)
};

export const ENDPOINTS_AUTH = {
	ACCESS: "access", // авторизация (post)
	REFRESH: "refresh", // обновление токена (get)
	RIGHTS: "rights", // права доступа (get)
	VERSION: "version", // версия системы (get)
	ROLES: "roles", // список ролей (get)
	ROLE_ADD: "role/add", // добавление роли (post)
	ROLE_EDIT: "role/modify", // изменение роли (post)
	ROLE_DELETE: "role/delete", // удаление роли (delete)
	DATASETS: "datasets", // список наборов данных (get)
	DATASET_ADD: "dataset/add", // добавление набора даннных (post)
	DATASET_EDIT: "dataset/modify", // изменение набора данных (post)
	DATASET_DELETE: "dataset/delete", // удаление набора данных (delete)
};

export const ENDPOINTS_USER = {
	LIST: "list", // список пользователей (get)
	GET: "get", // информация о пользователе (get)
	ADD: "add", // добавить пользователя (post)
	MODIFY: "modify", // изменить инфо пользователя (post)
	DELETE: "delete", // удалить пользователя (delete)
	INFO: "info", // информация о текущем пользователе (get)
	PASSWORD: "password", // изменить пароль текущего пользователя (post)
	DATASET: "dataset", // изменить набор данных (post)
	USER_LOGS: "userlog", // логи пользователей (post)
};

export const ENDPOINTS_MODEL = {
	LIST: "models", // список моделей (get)
	INFO: "info", // инфо о модели (get)
	EXPORT: "export", // экспорт .zip (get)
	IMPORT: "import", // импорт .zip, импорт всегда происходит в future; если future существовало, то оно затирается, если модели нет - то создается новая (post)
	DELETE: "delete", // полное удаление с сервера управления и всех серверов кластера (delete)
	COPY: "copy", // копирование версий модели (post)
	LOG: "log", // логи (get)
	ERRORS: "errors", // ошибки (get)
	HANDLER: "handler", // обработчик (get, post, delete) - получить, отправить, удалить
};

export const ENDPOINTS_SERVER = {
	ADDRESSES: "addresses", // все адреса серверов сервиса (get)
};

export const ENDPOINTS_AUTOMARK = {
	AUTOMARK_START: "automark/start", // старт авторазметки (get)
	AUTOMARK_STOP: "automark/stop", // остановка авторазметки (get)
	AUTOMARK_STATUS: "automark/status", // статус авторазметки (get)
	AUTOMARK_LIST: "automark/list", // список задач авторазметки (get)
	AUTOMARK_RESULT: "automark/result", // результат авторазметки (get)
};

export const ENDPOINTS_MARKS = {
	LIST: "list", // список меток (get)
	GET: "get", // получить метки (get)
	ADD: "add", // добавить (post)
	RENAME: "rename", // переименовывание (post)
	MODIFY: "modify", // изменение (post)
	COPY: "copy", // копирование (post)
	DELETE: "delete", // удаление (delete)
	IMPORT: "import", // импорт (post)
	EXPORT: "export", // экспорт .csv (get)
};

export const ENDPOINTS_SMC = {
	TEST: "test", // тестирование модели (post)
	MANUAL_CHECK: "classify", // ручная проверка модели (get)
	TRAIN: "train", // обучение модели (post)
	STOP_TRAIN: "stop", // остановка обучения модели (post)
	COMPRESS: "compress", // сжатие фразы (get)
	EMOTION: "emotion", // определение эмоции (get)
	GROUPS: "groups", // обновление групп в модели (post)
	PUNCTUATE: "punctuate", // пунктуация (get)
	CORRECT: "correct", // коррекция ошибок (get)
	NORMALIZE: "normalize", // обратная нормализация (get)
	TOXICITY: "toxicity", // анализ на токсичность (get)
};

export const ENDPOINTS_SEE = {
	MANUAL_CHECK: "entities", // ручная проверка модели (get)
	TRAIN: "train", // обучение модели (post)
	STOP_TRAIN: "stop", // остановка обучения модели (post)
};

export const ENDPOINTS_SPR = {
	RECOGNITION: "stt", // распознавание речи (post)
	ASYNC_RESULT: "result", // асинхронное распознавание речи (get)
	QUEUE: "queue", // очередь асинхронного распознавания/удаление задачи (get / delete)
	AUDIO: "audio", // экспорт распознанного аудио-файла (get)
	WAVEFORM: "waveform", // пики для построения аудио-дорожки (get)
};

export const ENDPOINTS_TRANSCRIPTION = {
	LIST: "list", // список сохраненных распознаваний (get)
	GET_DATA: "get", // получить данные сохраненного распознавания (get)
	GET_AUDIO: "audio", // получить аудио файл (get)
	WAVEFORM: "waveform", // пики для построения аудио-дорожки (get)
	CREATE: "create", // создать запись с сохраненным распознаванием (post)
	MODIFY: "modify", // пересохранение записи распознавания (post)
	SAVE: "save", // сохранить изменения сохраненного распознавания (post)
	DELETE: "delete", // удалить запись сохраненного распознавания (delete)
	METRICS: "errors", // метрики (GET)
};

export const ENDPOINTS_SBS = {
	SPEAKERS: "speakers/list", // список спикеров (get)
	SPEAKER_ADD: "speakers/add", // добавить спикера (post)
	SPEAKER_EDIT: "speakers/modify", // изменить спикера (post)
	SPEAKER_DELETE: "speakers/delete", // удалить спикера (delete)
	ANALYZE: "analyze", // анализ речи (post)
	NOISE_LEVEL: "noiselevel", // уровень шума (post)
	SEARCH: "search", // поиск спикера по аудиозаписи (post)
	VERIFY: "verify", // соответствие спикера и аудиозаписи (post)
};

export const ENDPOINTS_TTS = {
	SYNTHESIZE: "synthesize", // синтез речи (post)
	DICTIONARY_EXPORT: "dictionary/export", // экспорт словаря ударений .csv (get)
	DICTIONARY_IMPORT: "dictionary/import", // импорт словаря ударений (post)
	DICTIONARY_GET: "dictionary/get", // получить словарь ударений (get)
	DICTIONARY_PUT: "dictionary/put", // изменение словаря ударений (post)
	NORMALIZE: "normalize", // нормализация (post)
	PHONEMES: "phonemes", // преобразование в фонемы (post)
	REVOICERS_LIST: "revoicers", // список искажений голоса (get)
	REVOICE: "revoice", // искажение голоса (post)
};

export const ENDPOINTS_QAS = {
	SEARCH: "search", // поиск фрагмента документа, откуда был дан ответ на заданный вопрос (get)
	ASK: "ask", // ответ на заданный вопрос (get)
	GPT_LIST: "gpt/list", // список моделей gpt (get)
	CHAT: "chat", // чат (post)
	PARAPHRASE: "paraphrase", // перефразирование (post)
	REPLACEMENT_LIST: "replacementlist", // список всех фрагментов, подлежащих замене с разбивкой на документы и ответы (get)
	REPLACE: "replace", // замена информации в переданном тексте (post)
	COMPARE: "compare", // проверка семантики вопрос-ответ (post)

	DOC_LIST: "doc/list", // список документов (get)
	DOC_GET: "doc/get", // получить документ (get)
	DOC_ADD: "doc/add", // добавить документ (post)
	DOC_EDIT: "doc/modify", // изменение документа (post)
	DOC_DELETE: "doc/delete", // удалить документ (delete)
	DOC_GENERATE_ANNOTATION: "doc/generate_annotation", // сгенерировать аннотацию (post)
	DOC_REPLACE: "doc/replace", // поиск и замена текста в документах
	DOC_PHRASES_EDIT: "doc/modifyphrases", // массовая замена фраз в документе (post)

	QUESTION_LIST: "question/list", // список вопросов (get)
	QUESTION_GET: "question/get", // получить вопрос (get)
	QUESTION_ADD: "question/add", // добавить вопрос (post)
	QUESTION_EDIT: "question/modify", // редактировать данные вопроса (post)
	QUESTION_DELETE: "question/delete", // удалить вопрос (delete)
	QUESTION_LIST_DELETE: "question/delete/list", // удалить список вопросов (post)
	QUESTION_APPEND: "question/append", // добавить алиасы/кандидаты к другому вопросу (post)
	QUESTION_APPROVE: "question/approve", // перемещение кандидатов в формулировки другого вопроса (post)
	QUESTION_REPLACE: "question/replace", // поиск и замена текста в ответах (post)
	QUESTION_ANSWERS_EDIT: "question/modifyanswers", // массовая замена ответов (post)

	CATEGORY_LIST: "category/list", // список категорий (get)
	CATEGORY_ADD: "category/add", // добавить категорию (post)
	CATEGORY_EDIT: "category/modify", // изменить категорию (post)
	CATEGORY_DELETE: "category/delete", // удалить категорию (delete)
	CATEGORY_EXPORT: "category/export",
	CATEGORY_IMPORT: "category/import",

	ANSWER_MAKER_START: "cachemaker/start", // старт генерации ответов (get)
	ANSWER_MAKER_STOP: "cachemaker/stop", // остановка генерации ответов (get)
	ANSWER_MAKER_STATUS: "cachemaker/status", // статус генерации ответов (get)

	QUESTION_MAKER_START: "questionmaker/start", // старт генерации вопросов (get)
	QUESTION_MAKER_STOP: "questionmaker/stop", // остановка генерации вопросов (get)
	QUESTION_MAKER_STATUS: "questionmaker/status", // статус генерации вопросов (get)

	PROCESSING_QUESTIONS_START: "questionlist/start", // старт массовой обработки вопросов (post)
	PROCESSING_QUESTIONS_STOP: "questionlist/stop", // остановка массовой обработки вопросов (get)
	PROCESSING_QUESTIONS_STATUS: "questionlist/status", // статус массовой обработки вопросов (get)
	PROCESSING_QUESTIONS_LOG: "questionlist/answers", // лог массовой обработки вопросов (get)

	COPY_ANSWERS_WITH_CLEANING_START: "answerslist/start", // старт копирования ответов (post)
	COPY_ANSWERS_WITH_CLEANING_STOP: "answerslist/stop", // остановка копирования ответов (get)
	COPY_ANSWERS_WITH_CLEANING_STATUS: "answerslist/status", // статус копирования ответов (get)
	COPY_ANSWERS_WITH_CLEANING_LOG: "answerslist/answers", // лог копирования ответов (get)

	SUMMARIZE: "summarize", // протокол (post)
	TEMPLATE_LIST: "summarization_template/list", // список шаблонов протокола (get)
	TEMPLATE_GET: "summarization_template/get", // получить шаблон протокола (get)
	TEMPLATE_ADD: "summarization_template/add", // добавить шаблон протокола (post)
	TEMPLATE_EDIT: "summarization_template/modify", // изменить шаблон протокола (post)
	TEMPLATE_DELETE: "summarization_template/delete", // удалить шаблон протокола (delete)

	PROMPT_LIST: "prompt/list", // список промптов (get)
	PROMPT_GET: "prompt/get", // получить промпт (get)
	PROMPT_ADD: "prompt/add", // добавить промпт (post)
	PROMPT_EDIT: "prompt/modify", // изменить промпт (post)
	PROMPT_DELETE: "prompt/delete", // удалить промпт (delete)

	MISMATCH_SEARCHER_START: "mismatchsearcher/start", // старт поиска несоответствий кэша ответов и документов (post)
	MISMATCH_SEARCHER_STOP: "mismatchsearcher/stop", // остановка поиска несоответствий кэша ответов и документов (get)
	MISMATCH_SEARCHER_STATUS: "mismatchsearcher/status", // статус поиска несоответствий кэша ответов и документов (get)
	MISMATCH_SEARCHER_LOG: "mismatchsearcher/mismatches", // лог поиска несоответствий кэша ответов и документов (get)

	CLEAN_DOC_START: "cleandoc/start", // старт очистки документа от примесей (post)
	CLEAN_DOC_STOP: "cleandoc/stop", // остановка очистки документа от примесей (get)
	CLEAN_DOC_STATUS: "cleandoc/status", // статус очистки документа от примесей (get)
	CLEAN_DOC_RESULT: "cleandoc/result", // результат очистки документа от примесей (get)
};

export const ENDPOINTS_SES = {
	ROBOT_LIST: "robot/list", // список роботов (get)
	ROBOT_GET: "robot/get", // данные робота (get)
	ROBOT_ADD: "robot/add", // добавить робота (post)
	ROBOT_EDIT: "robot/modify", // изменить робота (post)
	ROBOT_DELETE: "robot/delete", // удалить робота (delete)
	ROBOT_COMMIT_CONFIG: "robot/commit", // применить настройки робота (post)
	ROBOT_APPLY: "robot/apply", // применить черновик робота в прод (post)
	ROBOT_RESTORE: "robot/restore", // восстановить робота из бэкапа (post)
	ROBOT_CLEAR_DRAFT: "robot/cleardraft", // обнулить черновик роботом прода (post)
	ROBOT_IMPORT: "robot/import", // импорт робота (post)
	ROBOT_EXPORT: "robot/export", // экспорт робота (get)
	ROBOT_SEARCH: "robot/search", // поиск текста по сценарию (post)

	DATA_LIST: "robot/data/list", // список элементов данных (get)
	DATA_GET: "robot/data/get", // элемент данных (get)
	DATA_ADD: "robot/data/add", // добавить данные (post)
	DATA_EDIT: "robot/data/modify", // изменить данные (post)
	DATA_DELETE: "robot/data/delete", // удалить данные (delete)

	ENDPOINT_LIST: "robot/endpoint/list", // список конечных точек (get)
	ENDPOINT_GET: "robot/endpoint/get", // получить конечную точку (get)
	ENDPOINT_ADD: "robot/endpoint/add", // добавить конечную точку (post)
	ENDPOINT_EDIT: "robot/endpoint/modify", // изменить конечную точку (post)
	ENDPOINT_DELETE: "robot/endpoint/delete", // удалить конечную точку (delete)

	SCRIPT_LIST: "robot/script/list", // список скриптов (get)
	SCRIPT_GET: "robot/script/get", // получить скрипт (get)
	SCRIPT_ADD: "robot/script/add", // добавить скрипт (post)
	SCRIPT_EDIT: "robot/script/modify", // изменить скрипт (post)
	SCRIPT_DELETE: "robot/script/delete", // удалить скрипт (delete)
	SCRIPT_TEST: "robot/script/test", // тестирование скрипта (post)

	ASK: "ask", // ответ робота в отладчике (post)
	SESSION: "session", // данные сессии отладчика (get)

	UPLOAD_FILE: "robot/files/upload", // загрузка файла (post)
	DOWNLOAD_FILE: "robot/files/download", // скачивание файла (get)

	CHAT_WIDGET: "widget/js", // чат-виджет (get)
	CHAT_WIDGET_CONFIG: "widget/config", // настройки чат-виджета (get)

	ARCHIVE_LIST: "archive/list", // список архива (get)
	ARCHIVE_DIALOG: "archive/dialog", // данные диалога (get)
	ARCHIVE_AUDIO: "archive/audio", // аудио диалога (get)
	ARCHIVE_WAVEFORM: "archive/waveform", // пики для построения аудио-дорожки (get)

	USERDATA_STRUCTURE_LIST: "robot/userdata/structure/list", // список пользовательских структур (get)
	USERDATA_STRUCTURE_ADD: "robot/userdata/structure/add", // добавить пользовательскую структуру (post)
	USERDATA_STRUCTURE_MODIFY: "robot/userdata/structure/modify", // изменить пользовательскую структуру (post)
	USERDATA_STRUCTURE_DELETE: "robot/userdata/structure/delete", // удалить пользовательскую структуру (delete)

	USERDATA_DATA_LIST: "robot/userdata/data/list", // список данных структуры (get)
	USERDATA_DATA_ADD: "robot/userdata/data/add", // добавить данные структуры (post)
	USERDATA_DATA_MODIFY: "robot/userdata/data/modify", // изменить данные структуры (post)
	USERDATA_DATA_PUT: "robot/userdata/data/put", // замена данных структуры (post)
	USERDATA_DATA_DELETE: "robot/userdata/data/delete", // удалить данные структуры (delete)

	CONNECTOR_LIST: "robot/connector/list", // список коннекторов (get)
	CONNECTOR_ADD: "robot/connector/add", // добавить коннектор (post)
	CONNECTOR_MODIFY: "robot/connector/modify", // редактировать коннектор (post)
	CONNECTOR_DELETE: "robot/connector/delete", // удалить коннектор (delete)

	HANDLER_LIST: "handler/list", // список обработчиков (get)
};

export const ENDPOINTS_CLS = {
	CALLING_LINE_LISTS: "lists/list", //получить список листов обзвона
	CALLING_LINE_ADD_CALLING_LIST: "lists/add", //добавить лист обзвона
	CALLING_LINE_MODIFY_CALLING_LIST: "lists/modify", // изменить лист обзвона
	CALLING_LINE_EXPORT_CALLING_LIST: "lists/export", // экспортировать лист обзвона
	CALLING_LINE_IMPORT_CALLING_LIST: "lists/import", // испортировать лист обзвона
	CALLING_LINE_DELETE_CALLING_LIST: "lists/delete", // удалить лист обзвона
	CALLING_LINE_LIST: "lists/list", // получить конкретный лист обзвона

	CALLING_LINE_SINGLE_CALL: "calls/call", //единичный звонок
	CALLING_LINE_START_CALLING: "calls/start", // начать обзвон по выбранному листу
	CALLING_LINE_STOP_CALLING: "calls/stop", // остановить обзвон текущего листа
	CALLING_LINE_SCHEDULE_CALLING: "instances/add", // запланировать обзвон по выбранному листу

	CALLING_LINE_TIMEINTERVALS_LIST: "timeintervals/list", // получить список интервалов для обзвонов
	CALLING_LINE_MODIFY_TIMEINTERVALS_LIST: "timeintervals/modify", // изменить список интервалов для обзвона
	CALLING_LINE_ADD_TIMEINTERVAL: "timeintervals/add", // добавить интервал для листов обзвона
	CALLING_LINE_DELETE_TIMEINTERVAL: "timeintervals/delete", // удалить интервал для листов обзвона

	CALLING_LINE_CONFIG_LIST: "configs/list", // получить список конфигов для листов обзвона
	CALLING_LINE_MODIFY_CONFIG_LIST: "configs/modify", // изменить конфиги для листов обзвонов

	CALLING_LINE_INSTANCES_LIST: "instances/list", // получить список список теущих инстанций
	CALLING_LINE_INSTANCES_DELETE_INSTANCE: "instances/remove",
	CALLING_LINE_LOGS: "logs/logs",
	CALLING_LINE_LIST_STATUS: "lists/status",
	CALLING_LINE_LIST_INSTANCE: "instances/get",

	CALLING_LINE_JOBS_LIST: "scheduler/jobs",
	CALLING_LINE_JOBS_PAUSE: "scheduler/pause",
	CALLING_LINE_JOBS_RESUME: "scheduler/resume",

	CALLING_LINE_RUN_SCRIPT_FOR_LIST: "lists/load",
};

export const ENDPOINTS_RES = {
	DASHBOARDS: "dashboards", // список рабочих столов отчетов (get)
	CUSTOM_FIELDS: "customfields", // список индексов и полей (get)
};
